import {
  DatePickerField,
  ReadOnlyField,
  SelectField,
  TextField,
} from '@agrotoken-tech/ui';
import { formatDate } from '@bcba/common-utils';
import { useTranslation } from '@bcba/react-hooks';
import { OWNERSHIP_TYPES } from '@bcba/types';
import { RadioField } from '../../../../../RadioField/RadioField';
import { MultipleDocumentSection } from '../../../../../shared/MultipleDocumentSection';
import { useCropPledgeFarmContext } from '../../context/CropPledgeFarmInformationContext';

const FarmPropietaryDataForm = () => {
  const { t } = useTranslation();
  const {
    defaultHasPropietaryInfo,
    formMethods,
    leaseContractTypeOptions,
    data,
    isFormReadOnly,
  } = useCropPledgeFarmContext();

  const { watch } = formMethods;

  const ownershipType = watch('ownershipType');

  return (
    <>
      <RadioField
        name="ownershipType"
        label={t('cropPledge.farmPropietaryData.form.isPropietary.label')}
        options={[
          { label: t('common.yes'), value: OWNERSHIP_TYPES.OWN },
          { label: t('common.no'), value: OWNERSHIP_TYPES.THIRD_PARTY },
        ]}
        defaultValue={defaultHasPropietaryInfo}
        rhfOptions={{ disabled: isFormReadOnly }}
      />
      <MultipleDocumentSection
        name="documentation"
        isDocumentRequired={false}
        label={t(
          'cropPledge.farmPropietaryData.form.aditionalDocumentation.label',
        )}
        additionalLabel={t(
          'cropPledge.farmPropietaryData.form.aditionalDocumentation.add',
        )}
        hideDelete={isFormReadOnly}
        isReadonly={isFormReadOnly}
        helperText={t(
          'cropPledge.farmPropietaryData.form.aditionalDocumentation.helperText',
        )}
        defaultReadOnlyName={t('common.toBeUploadedByBolsa')}
      />
      {ownershipType === OWNERSHIP_TYPES.THIRD_PARTY && (
        <>
          <SelectField
            name="leaseContractType"
            label={t('cropPledge.farmPropietaryData.form.contractType.label')}
            placeholder={t(
              'cropPledge.farmPropietaryData.form.contractType.placeholder',
            )}
            errorMessageFormatter={t}
            options={leaseContractTypeOptions}
            defaultInputValue={
              data?.leaseContractType
                ? t(
                    `common.LEASE_CONTRACT_TYPES.${data.leaseContractType}.title`,
                  )
                : ''
            }
            rhfOptions={{ required: true }}
            isReadOnly={isFormReadOnly}
            readOnlyValue={
              data?.leaseContractType
                ? t(
                    `common.LEASE_CONTRACT_TYPES.${data.leaseContractType}.title`,
                  )
                : '-'
            }
          />
          <TextField
            name={'ownerFiscalId'}
            label={t('cropPledge.farmPropietaryData.form.ownerFiscalId.label')}
            placeholder={t(
              'cropPledge.farmPropietaryData.form.ownerFiscalId.placeholder',
            )}
            errorMessageFormatter={t}
            rhfOptions={{ required: true }}
            isReadOnly={isFormReadOnly}
            readOnlyValue={data?.ownerFiscalId ?? '-'}
          />
          {isFormReadOnly ? (
            <>
              <ReadOnlyField
                label={t(
                  'cropPledge.farmPropietaryData.form.activityStartDate.label',
                )}
                value={data?.leasedFrom ? formatDate(data.leasedFrom) : '-'}
              />
              <ReadOnlyField
                label={t(
                  'cropPledge.farmPropietaryData.form.activityEndDate.label',
                )}
                value={data?.leasedUntil ? formatDate(data.leasedUntil) : '-'}
              />
            </>
          ) : (
            <>
              <DatePickerField
                name="leasedFrom"
                label={t(
                  'cropPledge.farmPropietaryData.form.activityStartDate.label',
                )}
                placeholder={t(
                  'cropPledge.farmPropietaryData.form.activityStartDate.placeholder',
                )}
                errorMessageFormatter={t}
                rhfOptions={{ required: true }}
              />
              <DatePickerField
                name="leasedUntil"
                label={t(
                  'cropPledge.farmPropietaryData.form.activityEndDate.label',
                )}
                placeholder={t(
                  'cropPledge.farmPropietaryData.form.activityEndDate.placeholder',
                )}
                errorMessageFormatter={t}
                rhfOptions={{ required: true }}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default FarmPropietaryDataForm;
